export * from './FileFormatJpgIcon';
export * from './FileFormatJpgIcon16Light';
export * from './FileFormatJpgIcon16Regular';
export * from './FileFormatJpgIcon16Solid';
export * from './FileFormatJpgIcon20Light';
export * from './FileFormatJpgIcon20Regular';
export * from './FileFormatJpgIcon20Solid';
export * from './FileFormatJpgIcon24Regular';
export * from './FileFormatJpgIcon24Solid';
export * from './FileFormatJpgIcon32Regular';
export * from './FileFormatJpgIcon64Regular';
